import {StoppageInfoDto, StoppageInfo} from '@domain/stoppages'
import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {usePlantUpmId} from '../common'

export const QueryKey = 'stoppages-suggestions'

export const useGetStoppagesSuggestions = (
  options?: UseQueryOptions<StoppageInfoDto[], AxiosError, StoppageInfo[]>
) => {
  const plantUpmId = usePlantUpmId()

  return useQuery<StoppageInfoDto[], AxiosError, StoppageInfo[]>({
    queryKey: [QueryKey, plantUpmId],
    queryFn: async () => {
      const path = '/rootcausefailureanalysis/stoppages/without-analysis'
      return (await ApiClient.axiosInstance.get<StoppageInfoDto[]>(path, {params: {plantUpmId}}))
        .data
    },
    // these default values will get moved to the api provider soon
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    throwOnError: true,
    retry: false,

    // allow the callee to override the default options
    ...options,
    select: (data) =>
      data.map((stoppage) => ({
        ...stoppage,
        id: stoppage.externalGroupId ?? stoppage.externalMainId
      }))
  })
}
